import { useQuery } from '@apollo/client/react/hooks';
import ConfigConnected from '@clearkit/icons/indicators/ConfigConnected';
import SpinnerMono from '@clearkit/icons/indicators/SpinnerMono';
import capitalize from 'lodash/capitalize';

import fieldMappingQuery from '~/pages/enrichment/Show/FieldMappingForm/fieldMappingQuery.graphql';

const idleColor = 'gray-600';
const successColor = 'green-600';

function SubObjectIntegrationStatus({
  accountConnectorId,
  subObjectType,
  onSubIntegrationsLoaded,
}) {
  const { data: { fieldMapping } = {}, loading: loading } = useQuery(
    fieldMappingQuery,
    {
      variables: {
        accountConnectorId: accountConnectorId,
        targetObjectType: capitalize(subObjectType),
      },
      onCompleted: (data) => {
        onSubIntegrationsLoaded(data.fieldMapping);
      },
    },
  );

  return (
    <div className="flex flex-row mr-4">
      <IndicatorIcon loading={loading} fieldMapping={fieldMapping} />
      <div className="flex flex-col">
        <div
          key={loading}
          className={`ml-1 font-medium text-sm text-${fontColor(
            loading,
            fieldMapping,
          )}`}>
          {capitalize(subObjectType)}
        </div>
        {!loading && (
          <div className="text-xs text-gray-600">
            Enriching {fieldMapping?.fieldMappings.length} Fields
          </div>
        )}
      </div>
    </div>
  );
}

function fontColor(loading, fieldMapping) {
  if (loading) {
    return idleColor;
  }
  if (fieldMapping?.enabled) {
    return successColor;
  } else {
    return idleColor;
  }
}

function IndicatorIcon({ loading, fieldMapping }) {
  if (loading) {
    return <SpinnerMono height="20" width="20" />;
  }
  if (fieldMapping?.enabled) {
    return <ConfigConnected height="20" width="20" />;
  } else {
    return <IdleConfigIcon height="20" width="20" />;
  }
}
// This is a hack since we don't currently have this icon in grey and we can't add to clearkit right now
function IdleConfigIcon(props) {
  const overrideColorStyle = {
    filter:
      'brightness(0) saturate(100%) invert(38%) sepia(5%) saturate(749%) hue-rotate(166deg) brightness(98%) contrast(97%)',
  };
  return <ConfigConnected style={overrideColorStyle} {...props} />;
}
export default SubObjectIntegrationStatus;
